import { createUseStyles } from 'react-jss';

const styles = {
  popover: {
    '&::part(content)': {
      padding: '0.4rem !important'
    }
  }
};

export const useStyles = createUseStyles(styles, {
  name: 'OverflowMenu'
});
